import { LinkableEntityType } from '@api';

type GetPersonSettlementCoHeadlinersArgsType = {
  coHeadliner1: LinkableEntityType | null;
  coHeadliner2: LinkableEntityType | null;
};

export const getPersonSettlementCoHeadliners = ({
  coHeadliner1,
  coHeadliner2,
}: GetPersonSettlementCoHeadlinersArgsType): LinkableEntityType[] => {
  return [coHeadliner1, coHeadliner2].filter(
    (coHeadliner): coHeadliner is LinkableEntityType => coHeadliner !== null
  );
};
